<div [id]="documentMapId + 'input'" class="pr-input-map-wrapper" style="margin-bottom: 30px">
  <pr-input-abstract
    [isDefault]="isDefault"
    [control]="fullAddress"
    [label]="label"
    [derrors]="derrors"
    [hidden]="!isGMaps"
    [required]="true"
  >
    <input
      #mapsInput
      matInput
      type="text"
      [formControl]="fullAddress"
      placeholder="Saisissez un lieu"
      style="width: 100%"
      class="pr-map-input"
      name="place"
    />
    <ng-content></ng-content>
  </pr-input-abstract>
  @if (control) {
    <div [formGroup]="control">
      <div [hidden]="isGMaps">
        <pr-input-country
          [formGroup]="control"
          [derrors]="derrors"
        ></pr-input-country>
        <pr-input label="Adresse" [derrors]="derrors"
          ><input formControlName="street" type="text" [readOnly]="disabled" />
        </pr-input>
        <pr-input label="Code postal" [derrors]="derrors"
          ><input
            formControlName="zipCode"
            type="text"
            [readOnly]="disabled"
            mask="99999"
        /></pr-input>
        @if (
          countries?.length && isSwisslifeProduct && !isCountryNotFR(control)
        ) {
          <div>
            <pr-input label="Ville" [derrors]="derrors">
              <pr-select-search
                formControlName="city"
                label="Ville"
                [options]="filteredCities(control)"
                optionValueKey="city"
                optionDisplayKey="city"
              >
              </pr-select-search>
            </pr-input>
            <pr-city-finder
              [cities]="cities"
              (citySelected)="onCitySelected($event)"
            ></pr-city-finder>
          </div>
        }
        @if (
          !countries?.length || !isSwisslifeProduct || isCountryNotFR(control)
        ) {
          <div>
            <pr-input label="Ville" [derrors]="derrors"
              ><input
                formControlName="city"
                type="text"
                [readOnly]="disabled"
              />
            </pr-input>
          </div>
        }
      </div>
      <div>
        @if (hasCedex) {
          <pr-input [label]="'Cedex'" [derrors]="derrors"
            ><input formControlName="cedex" type="text" [readOnly]="disabled"
          /></pr-input>
        }
      </div>
    </div>
  }

  @if (mapOptions != null && marker != null) {
    <div>
      <google-map
        [options]="mapOptions"
        width="{ width: isDefault ? '50%' : '100%' }"
        height="181px"
        [id]="documentMapId"
        [hidden]="!isGMaps"
      >
        <map-marker [position]="marker.position"></map-marker>
      </google-map>
    </div>
  }

  <button
    type="button"
    class="gmap-toggle"
    [hidden]="disabled || isSwisslifeProduct"
    (click)="isGMaps = !isGMaps"
  >
    {{
      isGMaps
        ? "Je ne trouve pas l'adresse"
        : 'Utiliser la recherche à nouveau.'
    }}
  </button>
</div>
